module.exports = __webpack_public_path__ + "08938aba067e58e71c1e3b44b12d7d6b.jpg";